import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { MODEL_FEE, MODEL_ITEM, MODEL_ORDERINFOMATION, MODEL_PIN } from '@/lib/outbound/useParcel';
import { MODEL_PAYMENT } from '@/lib/outbound/usePayment';
import { modelRequiredParcel } from '@/models/outbounds/requiredQuick';

export class ParcelState {
  // 결제정보
  public payment: outbound.payment = MODEL_PAYMENT();
  // 결제 해야 할 목록
  public paymentList: outbound.parcel.package[] = [];
  // 주문 작성 완료 목록
  public completeList: outbound.parcel.package[] = [];

  /**
   *  현재 작성중인 주문
   */
  public packageOrigin: outbound.pin = MODEL_PIN();
  public packageDestination: outbound.pin = MODEL_PIN();
  public packageItem: outbound.parcel.item = MODEL_ITEM();
  public packageFee: outbound.parcel.fee = MODEL_FEE();
  public packageOrderInfomation: outbound.parcel.orderInfomation = MODEL_ORDERINFOMATION();
  public validatePopup: boolean = false;
  public receptionTimePopup: boolean = false;

  public validationInfo: required.parcel = new modelRequiredParcel();
  public canUsePayment: boolean = false; //결제모달 오픈가능 여부

  public customerDropOffMethod: outbound.itemDeliveryMethod = '';
  public onsitePickupRequestedAt?: string;
  public onsitePickupClientComment?: string;

  public nowIspickupReserveOvertime?: boolean = false;
  public nowIspickupServiceOvertime?: boolean = false;
}

const Mutations: MutationTree<ParcelState> = {
  /**
   * 현재 작성중인 주문 목록 업데이트
   */
  updatePackageOrigin(state: ParcelState, payload: vuex.outbound.updateData<outbound.pin>) {
    state.packageOrigin[payload.key] = payload.value;
  },
  updatePackageDestination(state: ParcelState, payload: vuex.outbound.updateData<outbound.pin>) {
    state.packageDestination[payload.key] = payload.value;
  },
  updatePackageItem(state: ParcelState, payload: vuex.outbound.updateData<outbound.parcel.item>) {
    state.packageItem[payload.key] = payload.value;
  },
  updatePackageFee(state: ParcelState, payload: vuex.outbound.updateData<outbound.parcel.fee>) {
    state.packageFee[payload.key] = payload.value;
  },
  updatePackageOrderInfomation(state: ParcelState, payload: vuex.outbound.updateData<outbound.parcel.orderInfomation>) {
    state.packageOrderInfomation[payload.key] = payload.value;
  },

  /**
   * completeList(주문완료 목록) 변경
   */
  updateCompleteList(state: ParcelState, payload: outbound.parcel.package[]) {
    state.completeList = [...payload];
  },

  /**
   * paymentList(결제 목록) 변경
   */
  updatePaymentList(state: ParcelState, payload: outbound.parcel.package[]) {
    state.paymentList = [...payload];
  },

  /**
   *  payment(결제정보) 변경
   */
  updatePayment(state: ParcelState, payload: vuex.outbound.updateData<outbound.payment>) {
    state.payment[payload.key] = payload.value;
  },

  updateValidateInfo(state: ParcelState, payload: required.parcel) {
    state.validationInfo = payload;
  },

  resetValidateInfo(state: ParcelState, payload: required.parcel) {
    state.validationInfo = payload;
  },
  //결제모달오픈 여부 업데이트
  updateCanUsePayment(state: ParcelState, payload: boolean) {
    state.canUsePayment = payload;
  },

  updateCustomerDropOffMethod(state: ParcelState, payload: outbound.itemDeliveryMethod) {
    state.customerDropOffMethod = payload;
  },
  updateOnsitePickupRequestedAt(state: ParcelState, payload: string) {
    state.onsitePickupRequestedAt = payload;
  },
  updateOnsitePickupClientComment(state: ParcelState, payload: string) {
    state.onsitePickupClientComment = payload;
  },
  updateNowIspickupReserveOvertime(state: ParcelState, payload: boolean) {
    state.nowIspickupReserveOvertime = payload;
  },
  updateNowIspickupServiceOvertime(state: ParcelState, payload: boolean) {
    state.nowIspickupServiceOvertime = payload;
  },
};
const Actions: ActionTree<ParcelState, any> = {
  /**
   * 현재 작성중인 주문 목록 업데이트
   */
  updatePackageOrigin({ commit }, payload: vuex.outbound.updateData<outbound.pin>) {
    commit('updatePackageOrigin', payload);
  },
  updatePackageDestination({ commit }, payload: vuex.outbound.updateData<outbound.pin>) {
    commit('updatePackageDestination', payload);
  },
  updatePackageItem({ commit }, payload: vuex.outbound.updateData<outbound.parcel.item>) {
    commit('updatePackageItem', payload);
  },
  updatePackageFee({ commit }, payload: vuex.outbound.updateData<outbound.parcel.fee>) {
    commit('updatePackageFee', payload);
  },
  updatePackageOrderInfomation({ commit }, payload: vuex.outbound.updateData<outbound.parcel.orderInfomation>) {
    commit('updatePackageOrderInfomation', payload);
  },

  /**
   * completeList(주문완료 목록) 변경
   */
  updateCompleteList({ commit }, payload: outbound.parcel.package[]) {
    commit('updateCompleteList', payload);
  },

  /**
   * paymentList(결제 목록) 변경
   */
  updatePaymentList({ commit }, payload: outbound.parcel.package[]) {
    commit('updatePaymentList', payload);
  },

  /**
   *  payment(결제정보) 변경
   */
  updatePayment({ commit }, payload: vuex.outbound.updateData<outbound.payment>) {
    commit('updatePayment', payload);
  },

  updateValidateInfo({ commit }, payload: required.parcel) {
    commit('updateValidateInfo', payload);
  },

  resetValidateInfo({ commit }) {
    commit('resetValidateInfo', new modelRequiredParcel());
  },

  updateCanUsePayment({ commit }, payload: boolean) {
    commit('updateCanUsePayment', payload);
  },

  updateCustomerDropOffMethod({ commit }, payload: outbound.itemDeliveryMethod) {
    commit('updateCustomerDropOffMethod', payload);
  },
  updateOnsitePickupRequestedAt({ commit }, payload: string) {
    commit('updateOnsitePickupRequestedAt', payload);
  },
  updateOnsitePickupClientComment({ commit }, payload: string) {
    commit('updateOnsitePickupClientComment', payload);
  },
  updateNowIspickupReserveOvertime({ commit }, payload: boolean) {
    commit('updateNowIspickupReserveOvertime', payload);
  },
  updateNowIspickupServiceOvertime({ commit }, payload: boolean) {
    commit('updateNowIspickupServiceOvertime', payload);
  },
};

const Getters: GetterTree<ParcelState, any> = {
  getValidateInfo: (state: ParcelState) => (): required.parcel => {
    return state.validationInfo;
  },
  getNowIspickupReserveOvertime: (state: ParcelState) => (): boolean => {
    return state.nowIspickupReserveOvertime ?? false;
  },
  getNowIspickupServiceOvertime: (state: ParcelState) => (): boolean => {
    return state.nowIspickupServiceOvertime ?? false;
  },
  getCustomerDropOffMethod: (state: ParcelState) => (): outbound.itemDeliveryMethod => {
    return state.customerDropOffMethod;
  },
};

const module: Module<ParcelState, any> = {
  namespaced: true,
  state: new ParcelState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
